import { MunicipalityDto } from "../municipalityDto";
import { Municipality } from "../../../core/entities/municipality";

export function mapDtoToMunicipalities(dto: MunicipalityDto): Municipality {
    return {
        cvr: dto.cvr,
        code: dto.code,
        name: dto.name
    };
}
